import React from 'react';
import ReactDOM from 'react-dom/client';
import '@linktivity/link-styles';
import '@kurotetsu/individual/apis/fetchUtils';
import '@kurotetsu/individual/styles/index.css';
import '@kurotetsu/individual/i18n';
import App from '@kurotetsu/individual/App';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
